import { Routes, Route } from 'react-router-dom';
import ClerkProviderWithRoutes from './auth/ClerkProviderWithRoutes.jsx';
import { Layout } from './layout/Layout.jsx';
import { ThemeProvider } from './context/ThemeContext.jsx';
import LandingPage from './components/LandingPage.jsx';
import Dashboard from './components/Dashboard.jsx';
import { AuthenticationPage } from './auth/AuthenticationPage.jsx';
import { TestDashboard } from './components/TestDashboard.jsx';
import Success from './components/Success.jsx';
import CheckoutCallback from './components/CheckoutCallback.jsx';
import IntakeForm from './components/IntakeForm.jsx';
import GuestReport from './components/GuestReport.jsx';
import PurchaseCredits from './components/PurchaseCredits.jsx';
import NotFound from './components/NotFound.jsx';
// Guest-side marketplace components
import UserTypeSelection from './components/UserTypeSelection.jsx';
import GuestIntakeForm from './components/GuestIntakeForm.jsx';
import GuestDashboard from './components/GuestDashboard.jsx';
import ShowMatchReport from './components/ShowMatchReport.jsx';
import { sharedStyles } from './components/shared/sharedStyles.js';
import './App.css';

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <ClerkProviderWithRoutes>
          <Routes>
            <Route path="/sign-in/*" element={<AuthenticationPage />} />
            <Route path="/sign-up/*" element={<AuthenticationPage />} />
            <Route path="/checkout-callback" element={<CheckoutCallback />} />
            <Route element={<Layout />}>
              <Route path="/" element={<LandingPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/intake-form" element={<IntakeForm />} />
              <Route path="/report/:reportId" element={<GuestReport />} />
              <Route path="/purchase-credits" element={<PurchaseCredits />} />
              <Route path="/test" element={<TestDashboard />} />
              <Route path="/success" element={<Success />} />
              {/* Guest-side marketplace routes */}
              <Route path="/select-type" element={<UserTypeSelection />} />
              <Route path="/guest/intake-form" element={<GuestIntakeForm />} />
              <Route path="/guest/dashboard" element={<GuestDashboard />} />
              <Route path="/guest/show-matches/:matchId" element={<ShowMatchReport />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            {/* Development pages - commented out for pre-launch */}
            {/* {currentPage === 'intake' && <IntakeForm />}
              {currentPage === 'report' && <GuestReport />} */}

            {/* Development navigation - commented out for pre-launch */}
            {/* <div style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                display: 'flex',
                gap: '10px',
                zIndex: 1000
              }}>
                <button
                  onClick={() => setCurrentPage('landing')}
                  style={{
                    padding: '8px 16px',
                    background: currentPage === 'landing' ? sharedStyles.colors.primary : sharedStyles.colors.surfaceAlt,
                    color: currentPage === 'landing' ? 'white' : sharedStyles.colors.textSecondary,
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  Landing
                </button>
                <button
                  onClick={() => setCurrentPage('intake')}
                  style={{
                    padding: '8px 16px',
                    background: currentPage === 'intake' ? sharedStyles.colors.primary : sharedStyles.colors.surfaceAlt,
                    color: currentPage === 'intake' ? 'white' : sharedStyles.colors.textSecondary,
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  Intake Form
                </button>
                <button
                  onClick={() => setCurrentPage('report')}
                  style={{
                    padding: '8px 16px',
                    background: currentPage === 'report' ? sharedStyles.colors.primary : sharedStyles.colors.surfaceAlt,
                    color: currentPage === 'report' ? 'white' : sharedStyles.colors.textSecondary,
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  Guest Report
                </button>
              </div> */}
          </Routes>
        </ClerkProviderWithRoutes>
      </ThemeProvider>
    </div>
  );
}

export default App;
